module.exports = __webpack_public_path__ + "onboarding-process.efd8ed8d325d16d843924eadeaf27d97.hashedasset.svg";